import { render, staticRenderFns } from "./PageViewsList.vue?vue&type=template&id=6bb0234d"
import script from "./PageViewsList.vue?vue&type=script&lang=js"
export * from "./PageViewsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports